import React, { useState } from "react";
import { Text, View } from "react-native";
import { Typography, TypographySize } from "../Typography.component";
import { useBiblo } from "../../hooks/Biblo.hook";
import { getTextStyles, getViewStyles } from "../../helpers/getStyles.helper";
import { ErrorBoundary } from "../ErrorBoundary.component";
import { ReaderControls } from "./ReaderControls.component";
import { useProps } from "../../hooks/Props.hook";
import { ReaderControlsToggle } from "./ReaderControlsToggle.component";
export const ReaderHeader = _ref => {
  let {
    bio
  } = _ref;
  const [controlsShown, setControlsShown] = useState(false);
  const {
    readerOptions,
    defaultStyles,
    disableDefaultStyles: disableDefaultStylesGlobal,
    textParser
  } = useBiblo();
  const {
    propsFromBio,
    updatePropFromBio
  } = useProps();
  const disableDefaultStyles = disableDefaultStylesGlobal || readerOptions.disableDefaultStyles;
  const Container = readerOptions.headerComponent || View;
  const Title = readerOptions.headerTitleComponent || View;
  const Subtitle = readerOptions.headerSubtitleComponent || View;
  const Description = readerOptions.headerDescriptionComponent || View;
  const Tags = readerOptions.headerTagsComponent || View;
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "the header"
  }, /*#__PURE__*/React.createElement(Container, {
    bio: bio,
    style: getViewStyles(readerOptions.headerStyle, {
      padding: defaultStyles.spacing
    }, disableDefaultStyles),
    controlsShown: controlsShown,
    setControlsShown: setControlsShown
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      flexDirection: "row",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "headerTitleComponent"
  }, /*#__PURE__*/React.createElement(Title, {
    style: getViewStyles(readerOptions.headerTitleStyle, {
      flex: 1
    }, disableDefaultStyles),
    textStyle: readerOptions.headerTitleTextStyle,
    title: bio.title
  }, /*#__PURE__*/React.createElement(Typography, {
    bold: true,
    size: TypographySize.Large,
    style: readerOptions.headerTitleTextStyle,
    disableDefaultStyles: disableDefaultStyles
  }, textParser(bio.title, {
    type: "title",
    screen: "reader",
    scope: "file",
    style: getTextStyles(readerOptions.headerTitleTextStyle, {
      fontWeight: "bold"
    }, disableDefaultStyles)
  })))), readerOptions.headerControlsToggleHidden !== true && Object.keys(propsFromBio).filter(prop => propsFromBio[prop].type !== "hidden").length > 0 && /*#__PURE__*/React.createElement(View, {
    style: {
      alignSelf: "center"
    }
  }, /*#__PURE__*/React.createElement(ReaderControlsToggle, {
    controlsShown: controlsShown,
    setControlsShown: setControlsShown
  }))), bio.subtitle && !readerOptions.headerSubtitleHidden ? /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "headerSubtitleComponent"
  }, /*#__PURE__*/React.createElement(Subtitle, {
    style: getViewStyles(readerOptions.headerSubtitleStyle, {
      marginTop: defaultStyles.spacing
    }, disableDefaultStyles),
    textStyle: readerOptions.headerSubtitleTextStyle,
    subtitle: bio.subtitle
  }, /*#__PURE__*/React.createElement(Typography, {
    bold: true,
    style: readerOptions.headerSubtitleTextStyle,
    disableDefaultStyles: disableDefaultStyles
  }, textParser(bio.subtitle, {
    type: "subtitle",
    screen: "reader",
    scope: "file",
    style: getTextStyles(readerOptions.headerSubtitleTextStyle, {
      fontWeight: "bold"
    }, disableDefaultStyles)
  })))) : null, bio.description ? /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "headerDescriptionComponent"
  }, /*#__PURE__*/React.createElement(Description, {
    style: getViewStyles(readerOptions.headerDescriptionStyle, {
      marginTop: defaultStyles.spacing
    }, disableDefaultStyles),
    textStyle: readerOptions.headerDescriptionTextStyle,
    description: bio.description
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "the description"
  }, typeof bio.description === "string" ? /*#__PURE__*/React.createElement(Typography, {
    style: readerOptions.headerDescriptionTextStyle,
    disableDefaultStyles: disableDefaultStyles
  }, textParser(bio.description, {
    type: "description",
    screen: "reader",
    scope: "file",
    style: readerOptions.headerDescriptionTextStyle
  })) : bio.description))) : null, bio.tags && bio.tags.length && !readerOptions.headerTagsHidden ? /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "tags"
  }, /*#__PURE__*/React.createElement(Tags, {
    style: getViewStyles(readerOptions.headerTagsStyle, {
      marginTop: defaultStyles.spacing
    }, disableDefaultStyles),
    textStyle: readerOptions.headerTagsTextStyle,
    tags: bio.tags
  }, /*#__PURE__*/React.createElement(Typography, {
    style: readerOptions.headerTagsTextStyle,
    disableDefaultStyles: disableDefaultStyles
  }, /*#__PURE__*/React.createElement(Text, {
    style: disableDefaultStyles ? {} : {
      fontWeight: "bold"
    }
  }, "Tags:", " "), bio.tags.map((tag, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: tag
  }, /*#__PURE__*/React.createElement(Text, null, tag), index < bio.tags.length - 1 && /*#__PURE__*/React.createElement(Text, null, ", ")))))) : null, bio.props && Object.keys(bio.props).length > 0 && /*#__PURE__*/React.createElement(ReaderControls, {
    props: propsFromBio,
    updateProp: updatePropFromBio,
    shown: controlsShown,
    setShown: setControlsShown,
    parent: "header"
  })));
};
//# sourceMappingURL=ReaderHeader.component.js.map